import React from "react";
import './menu.scss';
import {Link as ScrollLink} from "react-scroll";
import {useTranslation} from "react-i18next";
import {useTrackVisit} from "../../../hooks/useTrackVisit";
import {Category} from "../../../interfaces/interfaces";
import {useCategories} from "../../../hooks/useCategories";


const Menu = ({props}: {
    props: {
        activePage: string | null;
        setActivePage: (name: string | null) => void;
        menuOpen: boolean;
    }
}) => {

    const categories: Category[] = useCategories()
    const {t} = useTranslation();
    const trackVisit = useTrackVisit();

    return (
        props.menuOpen && <div className={'Menu'}>
            <div className={"menu-wrapper"}>
                <ScrollLink to='home'
                            smooth={true}
                            duration={5}
                            offset={-250}
                            activeClass="active"
                            spy={true}
                            onSetActive={trackVisit}
                            className={"menu-element link-default"}>
                    {t("menu.home")}
                </ScrollLink>
                <ScrollLink to='about'
                            smooth={true}
                            duration={5}
                            offset={-250}
                            activeClass="active"
                            spy={true}
                            onSetActive={trackVisit}
                            className={"menu-element link-default"}>
                    {t("menu.about")}
                </ScrollLink>
                {categories.map(cat => (
                    <button
                        key={cat.id}
                        className="menu-element link-default"
                        onClick={() => props.setActivePage(cat.name.toLowerCase())}
                    >
                        {t(`menu.${cat.name.toLowerCase()}`, {defaultValue: cat.name})}
                    </button>

                ))}
                <ScrollLink to='specials'
                            smooth={true}
                            duration={5}
                            offset={-250}
                            activeClass="active"
                            spy={true}
                            onSetActive={trackVisit}
                            className={"menu-element link-default"}>
                    {t("menu.specials")}
                </ScrollLink>

                <ScrollLink to='workshop'
                            smooth={true}
                            duration={5}
                            offset={-250}
                            activeClass="active"
                            spy={true}
                            onSetActive={trackVisit}
                            className={"menu-element link-default"}>
                    {t("menu.workshop")}
                </ScrollLink>
                <ScrollLink to='testimony'
                            smooth={true}
                            duration={5}
                            offset={-250}
                            activeClass="active"
                            spy={true}
                            onSetActive={trackVisit}
                            className={"menu-element link-default"}>
                    {t("menu.testimony")}
                </ScrollLink>
            </div>
        </div>
    );
};
export default Menu;
